import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { AXIS, GRID, TOOLTIP_STYLE } from './ChartCard.js';

interface Row {
  label: string;
  current: number | null;
  prior: number | null;
}

/**
 * Noches Diamond por mes, año en curso vs previo (barras agrupadas).
 *
 * Color: el año previo va en gris recesivo (#64748b) y el actual en azul, la
 * MISMA codificación que `MonthlyYoYChart` usa en esta pantalla — el gris no es
 * una categoría más, es la línea base de referencia. El par pasa separación CVD
 * (ΔE 16.8), banda de luminosidad y contraste; la leyenda siempre está presente,
 * así que la identidad nunca depende solo del color.
 */
export function DiamondMonthlyChart({ data, anio }: { data: Row[]; anio: number }) {
  return (
    <ResponsiveContainer width="100%" height={280}>
      <BarChart data={data} margin={{ top: 8, right: 12, bottom: 8, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={GRID} />
        <XAxis dataKey="label" tick={AXIS} />
        <YAxis tick={AXIS} allowDecimals={false} />
        <Tooltip
          contentStyle={TOOLTIP_STYLE}
          formatter={(v: number) => (v == null ? '—' : v.toLocaleString('es-VE'))}
        />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        <Bar dataKey="prior" name={`${anio - 1}`} fill="#64748b" radius={[4, 4, 0, 0]} />
        <Bar dataKey="current" name={`${anio}`} fill="#3b82f6" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
